import { useTranslation } from "react-i18next";
import bgLeft from "@/assets/svgs/instructions-bg-left.svg";
import bgRight from "@/assets/svgs/instructions-bg-right.svg";
import { HeaderTextBlock } from "@/components/Typography";
import { Button } from "@/components/Button";
import { useTracking } from "@/requests/hooks/app";
import { useUser } from "@/requests/hooks/user";
import { useNavigate } from "react-router-dom";
import { COLLECT_HOME_URL } from "@/utils/const";

const SetupComplete = () => {
  const { t } = useTranslation();
  const { refetch } = useUser();

  const navigate = useNavigate();

  const { mutate: sendTracking } = useTracking();

  const completeOnboardingFlow = () => {
    refetch();
    sendTracking({
      eventName: "onboarding.payment.complete",
      additionalProperties: {
        product_name: "collect",
      },
    });

    navigate(COLLECT_HOME_URL);
  };

  const renderBackgroundLeft = () => (
    <div className="flex h-[380px] animate-grow-left items-center justify-start opacity-0 md:h-auto md:opacity-100">
      <img className="h-auto w-[80%]" src={bgLeft} />
    </div>
  );

  const renderBackgroundRight = () => (
    <div className="flex h-[380px] items-center justify-center opacity-20 md:h-auto md:animate-grow-right md:justify-end md:opacity-100">
      <img className="h-auto w-[80%]" src={bgRight} />
    </div>
  );

  const renderContent = () => (
    <div className="absolute z-20 h-full w-full pb-40 md:pb-[150px]">
      <div className="mx-auto flex h-full max-w-full flex-col items-center justify-start px-20 pt-[150px] md:max-w-[620px] md:justify-center md:px-[unset] md:pt-[unset]">
        <HeaderTextBlock
          align="center"
          featureText={t("emailOnboarding.setupComplete.header.feature")}
          featureTextColor="primary"
          headingText={t("emailOnboarding.setupComplete.header.heading")}
          descriptionText={t(
            "emailOnboarding.setupComplete.header.description",
          )}
        />
        <div className="mt-15 flex w-full justify-center self-center md:w-[360px]">
          <Button
            variant="gradient"
            onClick={completeOnboardingFlow}
            width="full">
            {t("emailOnboarding.setupComplete.goHomeButton")}
          </Button>
        </div>
      </div>
    </div>
  );

  const renderImages = () => (
    <div className="grid h-full w-full grid-cols-1 overflow-hidden pb-30 md:grid-cols-2">
      {renderBackgroundLeft()}
      {renderBackgroundRight()}
      {renderContent()}
    </div>
  );

  return <div className="h-screen w-screen">{renderImages()}</div>;
};

export default SetupComplete;
